// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"41c95618","445":"34e5591b","962":"41c95618"}[chunkId] + ".chunk.css";
};